import React from 'react';
import { useQuery } from '@apollo/client';
import { QUERY_ACADEMIES } from '../../../../../graphql/query/academie/queryAcademie';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { CreateLyceeState } from '../../../../../store/reducers/createLycee.reducer';
import { LoadingContainer } from 'components/molecules/Loaders/LoadingContainer';
import { QueryAcademiesQuery } from '../../../../../graphql/generated/graphql';
import FormCreateLyceeView from './FormCreateLycee.view';

export interface FormCreateLyceeTypes {
  lycee: CreateLyceeState;
  handleChange: (e: { target: { value: string; name: string } }) => void;
}

const FormCreateLycee = ({ lycee, handleChange }: FormCreateLyceeTypes) => {
  const { data, loading, error } = useQuery<QueryAcademiesQuery>(
    QUERY_ACADEMIES
  );

  if (loading) return <LoadingContainer />;
  if (!lycee || !data || error) return <ErrorContainer />;

  const academies = data.academies?.data?.map(academie => ({
    id: academie.id,
    name: academie.attributes?.name
  }));

  return (
    <FormCreateLyceeView
      lycee={lycee}
      handleChange={handleChange}
      academies={academies}
    />
  );
};

export default FormCreateLycee;
